import { render, staticRenderFns } from "./CourseCenter.vue?vue&type=template&id=c6d96ba6&scoped=true&"
import script from "./CourseCenter.vue?vue&type=script&lang=js&"
export * from "./CourseCenter.vue?vue&type=script&lang=js&"
import style0 from "./CourseCenter.vue?vue&type=style&index=0&id=c6d96ba6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6d96ba6",
  null
  
)

component.options.__file = "CourseCenter.vue"
export default component.exports